{
  "en": {
    "fileSharing": {
      "public": {
        "empty": {
          "title": "No files yet",
          "description": "There are no files in this share yet."
        }
      }
    }
  }
}
